'use client';

import mixpanel from 'mixpanel-browser';

// 初始化 Mixpanel，判断是否在客户端环境
if (typeof window !== 'undefined') {
  mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || '58863bfe6febaf0f44277b40b8918140', {
    debug: process.env.NODE_ENV !== 'production',
    track_pageview: true,
    persistence: 'localStorage'
  });
}

// 用于跟踪事件的辅助函数
const Mixpanel = {
  track: (name, props) => {
    if (typeof window !== 'undefined') {
      mixpanel.track(name, props);
    }
  },
  identify: (id) => {
    if (typeof window !== 'undefined') {
      mixpanel.identify(id);
    }
  },
  setProfile: (props) => {
    if (typeof window !== 'undefined') {
      mixpanel.people.set(props);
    }
  },
  pageView: (pageName) => {
    if (typeof window !== 'undefined') {
      mixpanel.track('页面浏览', { pageName });
    }
  }
};

export default Mixpanel;